<template>
  <div class="CommentRecord">
    <a-form-model layout="inline" style="margin-top: 15px">
      <a-form-model-item label="游戏名称" required>
        <a-select @change="changeGame" style="width: 198px" :filter-option="filterOption" :showSearch="true" v-model="search.contentName" placeholder="请选择游戏名称">
          <a-select-option :value="item.id" v-for="item in gameList" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
            <a-form-model-item label="版本名称">
        <a-select allowClear v-model="search.gameVersion" placeholder="请选择游戏版本" style="min-width: 180px" @change="changeGameVersion">
          <a-select-option :value="item.versionName" :key="item.id" v-for="item in gameVersionList">{{ item.versionName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="版本号">
        <a-select style="min-width: 180px" allowClear v-model="search.version" placeholder="请选择版本号">
          <a-select-option :value="item.version" :key="item.id" v-for="item in versionList">{{ item.version }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <!--<a-form-model-item label="游戏名称">
        <a-input placeholder="请输入游戏名称" allow-clear :maxLength="20" v-model="search.contentName" @keyup.enter="getList(1)" />
      </a-form-model-item>
      <a-form-model-item label="版本名称">
        <a-input placeholder="请输入" allow-clear :maxLength="30" v-model="search.versionName" @keyup.enter="getList(1)" />
      </a-form-model-item>-->
      <a-form-model-item label="游戏类型">
        <a-select allowClear v-model="search.contentType" placeholder="请选择游戏类型" style="width: 198px">
          <a-select-option :value="1">测评</a-select-option>
          <a-select-option :value="2">训练</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="时间区间" required>
        <a-range-picker
          v-model="times"
          @change="changeRange"
          :disabledDate="disabledDate"
          :show-time="{
            hideDisabledOptions: true,
          }"
          format="YYYY-MM-DD HH:mm:ss"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="getList(1)">查询</a-button>
      </a-form-model-item>
    </a-form-model>
    <div class="table">
      <a-table
        :columns="columns"
        :scroll="{ y: 300, x: 1300 }"
        rowKey="id"
        @change="handleTableChange"
        :pagination="table.tablePagination"
        :loading="table.tableLoading"
        :dataSource="table.tableDataSource"
      >
        <div slot="contentType" slot-scope="text">
          {{ text.contentType == 1 ? '测评' : '训练' }}
        </div>
        <div slot="evaluationRate" slot-scope="text">{{ text.evaluationRate }}%</div>
        <div slot="versionName" slot-scope="text">{{ text.versionName || '--' }}</div>
        <a v-permission="'/content/GamesComment/ViewRecord'" slot="action" slot-scope="text" @click="view(text)">查看</a>
      </a-table>
    </div>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { getSkipList, EGamegeVersion } from '@/utils/http'
import moment from 'moment'
const columns = [
  { title: '游戏名', dataIndex: 'contentName', fixed: 'left', width: 130 },
  {
    title: '版本号',
    dataIndex: 'version',
    fixed: 'left',
    width: 120,
    filters: [],
    onFilter: (value, record) => record.version === value,
  },
  { 
    title: '版本名', 
    fixed: 'left', 
    width: 120,
    scopedSlots: { customRender: 'versionName' },
  },
  { title: '游戏类型', scopedSlots: { customRender: 'contentType' }, fixed: 'left', width: 120 },
  { title: '使用次数', sorter: true, dataIndex: 'usageCount', key: 'usageCount' },
  { title: '完成次数', sorter: true, dataIndex: 'completedCount', key: 'completedCount' },
  {
    title: '退出次数',
    children: [
      { title: '退出次数', sorter: true, dataIndex: 'quitCount', key: 'quitCount' },
      { title: '引导关', sorter: true, dataIndex: 'guideCount', key: 'guideCount' },
      { title: '练习关', sorter: true, dataIndex: 'exciseCount', key: 'exciseCount' },
      { title: '正式关', sorter: true, dataIndex: 'resultDataCount', key: 'resultDataCount' },
    ],
  },
  { title: '跳过次数', sorter: true, dataIndex: 'skipCount', key: 'skipCount' },
  { title: '跳过率', sorter: true, scopedSlots: { customRender: 'evaluationRate' }, key: 'evaluationRate' },
  { title: '操作', scopedSlots: { customRender: 'action' } },
]
export default {
  name: 'CommentRecord',
  data() {
    return {
      moment,
      times: [],
      gamePrimaryList: [],
      gameList: [],
      versionList: [],
      gameVersionList: [],
      search: {
        contentName: undefined,
        version: undefined,
        gameVersion: undefined,
        versionName: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
      },
      columns,
      table: tableRelevant.call(this),
      gameIdFromUrl: undefined,
    }
  },
  created() {
    const cuuentTime = moment()
    const prevTime = moment().subtract(1, 'months')
    this.search.startTime = prevTime.format('YYYY-MM-DD HH:mm:ss')
    this.search.endTime = cuuentTime.format('YYYY-MM-DD HH:mm:ss')
    this.times = [prevTime, cuuentTime]
    
    // 如果 URL 上有 gameId，尝试自动选择该游戏
    if (this.$route.query.gameId) {
      this.gameIdFromUrl = this.$route.query.gameId
    }
  },
  mounted() {
    if (this.$route.query.startTime) {
      this.search.startTime = this.$route.query.startTime
      this.search.endTime = this.$route.query.endTime
      this.times = [moment(this.search.startTime), moment(this.search.endTime)]
    }
    this.getGameSelect()
  },
  methods: {
    filterOption(input, option) {
      const re = new RegExp(`[${input}]`, 'g')
      const match = option.componentOptions.children[0].text.match(re)
      if (match) {
        return match.length >= input.length
      }
      return false
    },
    changeGame(e) {
      if (!e) {
        return
      }
      const game = this.gamePrimaryList.find((v) => v.id == e) || {}
      this.search.contentName = game.name
      this.search.version = undefined
      this.search.gameVersion = undefined
      // 清空版本号列表
      this.gameVersionList = []
      // 获取该游戏名下所有版本号（version）和游戏版本（versionName）
      this.getGameVersions(game.name)
      if (this.$route.query.gameId) {
        this.search.gameVersion = this.gameVersionList.find(f => f.id == this.$route.query.gameId)?.versionName
        this.changeGameVersion(this.search.gameVersion)
        this.$router.replace({
          query: {}
        })
      }
      this.getList(1)
    },
    changeGameVersion(e) {
      // 根据游戏名称和游戏版本确定唯一的游戏ID
      if (!this.search.contentName || !this.search.gameVersion) {
        return
      }
      // 清空版本号列表
      this.versionList = []
      const version = this.gameVersionList.find(f => f.versionName == e);
      if (version){
        EGamegeVersion({ id: version.id }).then((res) => {
          const versionData = res.data.data || []
          if (versionData && versionData.length > 0) {
            this.versionList = versionData
            this.updateVersionFilters(versionData)
          }
        })
      }
    },
    onChangeGameVersion() {
      // 触发 changeGameVersion 方法
      this.changeGameVersion()
    },
    getGameVersions(contentName) {
      // 获取该游戏名下所有游戏记录
      this.gameVersionList = this.gamePrimaryList
      .filter((v) => v.name === contentName)
      .map(m => {
        m.dataIndex = m.versionName ? 1 : 9
        m.versionName = m.versionName || '--';
        return m;
      }).sort((a, b) => a.dataIndex - b.dataIndex);
    },
    getGameSelect(callback) {
      this.$http.GamesComment.getAllContentByType({ contentTypeList: [1, 2] }).then((res) => {
        this.gamePrimaryList = res.data;
        this.gameList = (res.data || []).reduce((pre, cur) => {
          if (!pre.find((f) => f.name === cur.name)) {
            pre.push(cur)
          }
          return pre
        }, [])
        if (this.$route.query.gameId) {
          this.changeGame(this.$route.query.gameId)
        }
        callback && callback()
      })
    },
    changeRange(e = []) {
      if (e.length === 0) {
        this.search.startTime = undefined
        this.search.endTime = undefined
      } else {
        this.search.startTime = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.search.endTime = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      this.$router.push({
        query: {
          startTime: this.search.startTime,
          endTime: this.search.endTime,
        },
      })
    },
    clearSearch() {
      this.search = {
        contentName: undefined,
        version: undefined,
        gameVersion: undefined,
        versionName: undefined,
        contentType: undefined,
        minScore: undefined,
        maxScore: undefined,
        orderBy: undefined,
        isDesc: undefined,
      }
      // 重置版本号筛选条件
      this.$set(this.columns, 1, {
        ...this.columns[1],
        filters: [],
        filteredValue: [],
      })
      // 清空版本号列表
      this.versionList = []
      this.getList(1)
    },
    handleTableChange(pagination, filters, sorter) {
      const { order = '', columnKey } = sorter
      const map = {
        ascend: false,
        descend: true,
      }
      this.search.OrderByDesc = map[order]
      if (typeof columnKey === 'string') {
        this.search.OrderByName = columnKey.slice(0, 1).toUpperCase() + columnKey.slice(1)
      }
      if (map[order] === undefined) {
        this.search.OrderByName = undefined
      }
      // 处理版本号筛选
      if (filters.version) {
        this.search.version = filters.version[0]
      } else {
        this.search.version = undefined
      }
      // 处理版本名筛选
      if (filters.versionName) {
        this.search.versionName = filters.versionName[0]
      } else {
        this.search.versionName = undefined
      }
      this.getList()
    },
    // 获取列表数据
    getList(pageIndex) {
      if (!this.search.contentName) {
        this.$message.error('请选择游戏名称')
        return
      }
      if (!this.search.startTime) {
        this.$message.error('请选择时间区间')
        return
      }

      let params = {
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.search,
      }
      if (params.version === '无版本名 ') {
        params.version = ''
      }
      // 将版本号参数名改为 contentVersion
      if (params.version !== undefined && params.version !== '') {
        params.contentVersion = params.version
        delete params.version
      }
      // 将游戏版本参数名处理
      if (params.gameVersion === '无版本名 ') {
        params.gameVersion = ''
      }
      // 将游戏版本参数名改为 VersionName
      if (params.gameVersion !== undefined) {
        // 选择"--"时传空字符串
        if (params.gameVersion === '--') {
          params.VersionName = ''
        } else {
          params.VersionName = params.gameVersion
        }
        delete params.gameVersion
      }
      // 将版本名称（column 3 的 versionName）参数名改为 VersionName
      if (params.versionName !== undefined && params.versionName !== '') {
        params.VersionName = params.versionName
        delete params.versionName
      }
      this.table.tableLoading = true
      getSkipList(params)
        .then((res) => {
          const { data } = res
          this.table.tableDataSource = data.items
          this.table.tablePagination.total = data.totalCount
          this.table.tablePagination.current = data.pageIndex
        })
        .finally(() => {
          this.table.tableLoading = false
        })
    },
    updateVersionFilters(data) {
      const filters = (data || []).map((item) => ({
        text: item.version,
        value: item.version,
      }))
      this.$set(this.columns, 1, {
        ...this.columns[1],
        filters: filters,
        filteredValue: [],
      })
      // 更新表格版本名列的显示数据（VersionName 参数）
      // 从 data.items 中提取所有唯一的 versionName 字段
      const versionNames = [...new Set(data.map((item) => item.versionName).filter(Boolean))]
      // 检查是否有版本名为空的数据
      const hasEmptyVersionName = data.some((item) => !item.versionName || item.versionName === '')
      if (hasEmptyVersionName) {
        versionNames.push('--')
      }
      if (versionNames.length > 0) {
        this.$set(this.columns, 2, {
          ...this.columns[2],
          filters: versionNames.map((vn) => ({
            text: vn,
            value: vn,
          })),
          filteredValue: [],
        })
      }
    },

    // 查看
    view(text) {
      text.id = text.contentId
      let path = ''
      if (text.contentType === 1) {
        path = '/content/ScienceEvaluation/Statistics'
        this.$store.commit('content/setEvaluationGameInfo', text)
      } else {
        path = '/content/Traingame/Statistics'
        this.$store.commit('content/setTrainGameInfo', text)
      }
      window.open(path + `?type=${text.contentType}&name=${text.contentName}&versionName=${text.version}`)
    },
    disabledDate(current) {
      return current && current < moment('2019').startOf('day')
    },
  },
}
</script>

<style scoped>
.CommentRecord {
}
.table {
  margin-top: 15px;
}
</style>
